"use client"

import { isAbstractWalletAccount } from "../lib/wagmi/helpers"
import { useConnectorId } from "../polychain/hooks/useConnectorId"

/**
 * Hook to determine if the current wallet is an abstract wallet account
 * @returns boolean indicating if the current connector is an abstract wallet
 */
export function useIsAbstractWalletAccount(): boolean {
  const connectorId = useConnectorId()

  return connectorId ? isAbstractWalletAccount(connectorId) : false
}
